export const GOOGLE_PLAY_STORE_APP_URL = "https://play.google.com/store/apps/details?id=com.capitalrx.advantage";
export const APPLE_STORE_APP_URL = "https://apps.apple.com/us/app/crx-advantage-savings/id1516648365";
export const MIN_SEARCH_LENGTH = 3;
export const CAPITALRX_BRAND_NAME = "Capital Rx";
export const CAPITALRX_CARD_BRAND_NAME = "Advantage";
export const JUDI_BRAND_NAME = "Judi Rx";
export const JUDI_CARD_BRAND_NAME = "Discount";
export const CARD_NAME = "Card";
export const SAVINGS_NAME = "Savings";
